import { createRequest } from '@shared/services';

interface GetMemberBindSSOArgs {
    source: ThirdPartyAuthList['source'];
}

interface DeleteMemberBindSSOArgs {
    authId: string;
}

export async function getMemberBindSSO(args: GetMemberBindSSOArgs) {
    const { source } = args;

    const request = createRequest<BasicSSOResponse>({
        url: `/member/bind-social-login/${source}`,
        method: 'GET',
        withAuthorization: true,
    });

    return request.execute();
}

export async function deleteMemberBindSSO(args: DeleteMemberBindSSOArgs) {
    const { authId } = args;

    const request = createRequest<BasicSSOResponse>({
        url: `/member/unbind-social-login/${authId}`,
        method: 'DELETE',
        withAuthorization: true,
    });

    return request.execute();
}
